export enum RestoreTo {
  All = 'All',
  Folder = 'Folder',
  Messages = 'Messages'
}

export interface AnotherUserSettings {
  type: RestoreTo;
  userId: string;
  folder: string;
  messages: string[];
  subFolders?: boolean;
}
